import affIdCheck from "./checkForAffiliateId";
import sdkProvider from "../helpers/sdk-provider";
import getUserLoginStatus from "./getUserLoginStatus";
import { getViewportDimensions } from "../helpers/getViewportDimensions";

export default async (eventName, props = {}, extraProps) => {
  if (typeof window === "undefined") return;
  const { pageName, buttonType, currentTier } = props;
  const {
    platform = "",
    browseCountry = "",
    browseCurrency = "",
  } = window.asos.webContext.getWebContext();
  const identity = await sdkProvider("identity");
  const isAuthenticated = await identity.customer.isAuthenticated();
  const customerId = await identity.customer.customerId();
  const pageUrl = encodeURI(window.location.href.replace(/%20/gi, "+"));
  const s = window && window.s;
  const prop1 = "homepage";
  const prop2 = "discover";
  const prop3 = pageName;

  const commonProps = {
    pageName,
    prop1,
    prop2,
    prop3,
    prop8: "discover",
    prop31: getUserLoginStatus({ isAuthenticated }),
    eVar10: customerId,
    eVar12: affIdCheck(),
    eVar60: pageName,
    eVar61: pageName,
    channel: "homepage",
    ...extraProps,
  };

  const getProp6 = (s) =>
    s.getQueryParamValue("CTAref", true) !== ""
      ? s.getQueryParamValue("CTAref", true).toLowerCase()
      : "";

  const config = {
    "page-load": {
      linkVars: {
        prop4: `${prop1}~${prop2}~${prop3}`,
        eVar10: customerId,
        eVar12: affIdCheck(),
        eVar60: pageName,
        eVar61: pageName,
        eVar145: props.currentTier ? currentTier : undefined,
        eVar180: `${platform} web`,
        ...commonProps,
      },
    },
    "loyalty-button-click": {
      eventName: "loyalty button click",
      linkType: "o",
      linkVars: {
        prop5: s.getCustomTimeDate().toString().toLowerCase(),
        prop6: getProp6(s),
        prop10: `discover|${s.getPreviousValue(s.pageName, "gpv_p10")}`,
        prop11: pageUrl,
        prop25: browseCountry,
        eVar1: s.getVisitNum(),
        eVar6: `${s
          .getPreviousValue(s.pageName, "gpv_p10", "")
          .toLowerCase()}|${pageName}`,
        eVar17: s.getNewRepeat(365),
        eVar19: getViewportDimensions(),
        eVar33: browseCurrency,
        eVar47: s.getPreviousValue(s.eVar6, "gpv_e47", ""),
        eVar106: `${pageName}|${buttonType}|click`,
        eVar112: browseCountry,
        eVar113: browseCurrency,
        ...commonProps,
      },
      eventVars: {
        event172: "event172",
      },
    },
    "members-day-button-click": {
      eventName: "members day button click",
      linkType: "o",
      linkVars: {
        prop5: s.getCustomTimeDate().toString().toLowerCase(),
        prop6: getProp6(s),
        prop10: `discover|${s.getPreviousValue(s.pageName, "gpv_p10")}`,
        prop11: pageUrl,
        prop25: browseCountry,
        eVar1: s.getVisitNum(),
        eVar6: `${s
          .getPreviousValue(s.pageName, "gpv_p10", "")
          .toLowerCase()}|${pageName}`,
        eVar17: s.getNewRepeat(365),
        eVar19: getViewportDimensions(),
        eVar33: browseCurrency,
        eVar47: s.getPreviousValue(s.eVar6, "gpv_e47", ""),
        eVar106: `${pageName}|${buttonType}|click`,
        eVar112: browseCountry,
        eVar113: browseCurrency,
        ...commonProps,
      },
      eventVars: {
        event172: "event172",
      },
    },
  };
  return config[eventName];
};
